module.exports = __webpack_public_path__ + "static/media/img-background2.efa5b5f4.jpg";